export default class Environment {
  static playAnimation (season) {
    console.log(season, 111111);
    window.appInstance.uniCall('playAnimation', {
      animationName: 'SwitchSeason', //切换季节
      state: season
    }, res => {
      console.log(res, season, 111111);
    })
  }
  static  adddianziweilan () {
    let jsonData = {
      id: 'circularArea',//图层对象id，新建时调用者自己传入的唯一标识，用于各种操作的对象识别
      name: '圆形区域轮廓',//图层名称，支持为图层自定义名称
      coordType: 0,//XY轴坐标类别，0：X经度，Y纬度；1：X米，Y米，相对世界00点
      coordTypeZ: 0,//Z轴坐标类别，0：相对3D世界0海拔；1：相对3D世界地表；2：相对3D模型表面（单位：米）
      coordZ: -70,//Z轴高度（单位：米）
      type: 'Gradient02',//区域边界样式类别Arrow01Gradient01Gradient02Gradient03Grid01Grid02Grid03Grid04Grid05Segment01Segment02Segment03
      color: '#FFFF00',//颜色（HEX颜色值）
      areaHeight: 130,//围栏高度（单位：米）
      fillArea: 'none',//区域填充样式类别Gradient01Gradient02Grid01Grid02Segment01Segment02
      center: [-0.00016449811, -0.00029737752],//圆心XY轴坐标，X：经度；Y：纬度
      radius: 140,//半径（单位：米）
      fillPosition: 'top',//区域填充的位置，top/bottom，默认top
      tag: "custominfo",//用户自定标签，用户保存用户的扩展数据
      visible: true,//添加当前图层时默认是显示还是隐藏
    };

    window.appInstance.uniCall('clearOverlayType', {
      overlayType: 'circularArea',//覆盖物类型，支持all
    },
      result => {
        console.log(result);
      }
    );
    window.appInstance.uniCall('addCircularArea', jsonData, result => {
      console.log(result);
      if (result.result === 1) {
     
      }
    });
  }


}
